import WizardCard from '../morning/WizardCard.jsx';

// Step 2: For each MIT, ask whether to carry forward to tomorrow. Surfaces
// as suggestions in next morning's briefing step 5.
export default function StepCarryForward({
  briefing,
  checkout,
  onUpdate,
  onBack,
  onNext,
}) {
  const slots = [1, 2, 3].map((i) => ({
    slot: i,
    text: briefing?.[`mit_${i}_text`] || `(MIT ${i} not set)`,
    done: checkout?.[`mit_${i}_done`],
    carry: checkout?.[`mit_${i}_carry_forward`],
  }));

  function setCarry(slot, carry) {
    onUpdate({ [`mit_${slot}_carry_forward`]: carry });
  }

  const allAnswered = slots.every((s) => s.carry === true || s.carry === false);

  return (
    <WizardCard
      step={2}
      totalSteps={4}
      title="Carry any of these to tomorrow?"
      subtitle="Carry-forwards surface as suggestions in tomorrow's briefing."
      onBack={onBack}
      onNext={onNext}
      nextDisabled={!allAnswered}
    >
      <div className="space-y-3">
        {slots.map((s) => (
          <div key={s.slot} className="border border-border-base rounded p-3">
            <div className="flex items-start gap-2 mb-2">
              <span className="text-text-muted text-sm">{s.slot}.</span>
              <span
                className={`flex-1 text-sm ${
                  s.done ? 'line-through text-text-muted' : 'text-text-primary'
                }`}
              >
                {s.text}
              </span>
              {s.done && (
                <span className="text-[10px] uppercase tracking-wide text-accent-green">
                  done
                </span>
              )}
            </div>
            <div className="flex gap-2">
              <Choice
                label="Yes, carry forward"
                active={s.carry === true}
                onClick={() => setCarry(s.slot, true)}
              />
              <Choice
                label="No"
                active={s.carry === false}
                onClick={() => setCarry(s.slot, false)}
              />
            </div>
          </div>
        ))}
      </div>
    </WizardCard>
  );
}

function Choice({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`flex-1 py-1.5 text-sm font-medium rounded border transition ${
        active
          ? 'bg-accent-blue text-white border-accent-blue'
          : 'bg-bg-input text-text-primary border-border-base hover:border-accent-blue/40'
      }`}
    >
      {label}
    </button>
  );
}
